/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 *
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */

import { memo } from 'react';
import type { FC } from 'react';

import { icons } from '@assets/index';
import { ImgStyled } from '@components/common/Block/Img';
import { FormLabelHintStyled, FormLabelStyled } from '@components/common/FormStyled/FormStyled';
import { LabelMarkStyled } from '@components/common/Input/styled/InputStyled';
import ArrowTooltip from '@components/common/Tooltip/Tooltip';

interface IFieldLabelProps {
    name: string;
    prompt?: string;
    required?: boolean;
    className?: string;
}

export const FieldLabel: FC<IFieldLabelProps> = memo(({ className, name, required, prompt }) => {
    return (
        <FormLabelStyled style={{ display: 'flex' }}>
            {
                name
            }
            {
                required && <LabelMarkStyled>*</LabelMarkStyled>
            }
            {
                prompt && (
                    <FormLabelHintStyled className={className}>
                        <ArrowTooltip title={prompt}>
                            <ImgStyled className="small" src={icons.infoBlueIcon} />
                        </ArrowTooltip>
                    </FormLabelHintStyled>
                )}
        </FormLabelStyled>
    );
});

